import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { useSelector } from 'react-redux';

const ProtectedRoute = ({ children, allowedRoles }) => {
  const { isAuthenticated, user } = useSelector((state) => state.auth);
  const location = useLocation();

  if (!isAuthenticated) {
    return <Navigate to="/login" replace state={{ from: location }} />;
  }

  if (allowedRoles && !allowedRoles.includes(user.role)) {
    // Redirect based on role if they try to access unauthorized page
    if (user.role === 'super_admin') return <Navigate to="/admin/dashboard" replace />;
    if (user.role === 'bde') return <Navigate to="/bde/dashboard" replace />;
    return <Navigate to="/login" replace />;
  }

  if (user.role === 'bde' && user.status !== 'verified' && location.pathname !== '/pending') {
     return <Navigate to="/pending" replace />;
  }

  return children;
};

export default ProtectedRoute;
